<style scoped>
  .con-flex{
    display:flex;
  }
  .con-flex /deep/ .ivu-card-body{padding:0}
  .con-flex /deep/ .ivu-table-cell{padding-left:5px;padding-right:5px}
  .con-table{flex:1}
  .con-side{width: 320px; margin-left:20px}
</style>
<template>
  <content-layout :title="title" :tabs="tabs" v-model="activeTab" :spin-show='spinShow'>
    <div class="activity-item mgui-container" slot="/data">
      <div class="filter-row">
            <Input v-model="params.title" :clearable="true" style="width:100px;margin-right:5px" @on-clear="search" placeholder="筛选标题"></Input>
            <Button type="primary" @click.stop="search" icon="md-search" style="margin-right:20px">筛选</Button>
            关键字：
            <template v-for="item in keys">    
                <Badge :count="item.count" :key="item.id" v-if="item.count>0" style="margin-right:15px">
                    <Button :type="params.title==item.content?'primary':'default'" @click="keySearch(item.content)">
                        {{item.content}}
                    </Button>
                </Badge>
            </template>
      </div>
        <div class="con-flex">
            <Card class="con-table">
                <Table :columns="columns" :data="lists.data"></Table>
                <div class="pager">
                    <Page v-if="JSON.stringify(lists) != '{}'" :current="lists.current_page" :total="lists.total" :page-size="15" @on-change="pagerChange" show-elevator></Page>
                </div>
            </Card>
            <div class="con-side mobile-hide">
                <Card title="所有关键字" style="margin-bottom:15px"> 
                    <div style="padding:10px">
                        <Badge  v-for="item in keys" :count="item.count" :key="item.id" style="margin-right:15px;margin-bottom: 10px;">
                            <Button :type="params.title==item.content?'primary':'default'" @click="keySearch(item.content)">
                                {{item.content}}
                            </Button>
                        </Badge>
                    </div>
                </Card>
                <Card>
                    <Table :columns="ruleColumns" @on-selection-change="ruleSelect" :data="rules.data"></Table>
                    <div class="pager">
                        <Page v-if="JSON.stringify(rules) != '{}'" :current="rules.current_page" :total="rules.total" :page-size="15" @on-change="pagerChange" show-elevator></Page>
                    </div>
                </Card>
            </div>
        </div>
        <Drawer title="数据源" v-model="ruleFromVisible" :width="640">
            <Form ref="ruleForm" :model="ruleForm" :rules="ruleValidate" :label-width="80">
                <FormItem label="站点名称" prop="title">
                    <Input v-model="ruleForm.title" placeholder="网站名称"></Input>
                </FormItem>
                <FormItem label="网址" prop="path">
                    <Input v-model="ruleForm.path" placeholder="http://|https://"></Input>
                </FormItem>
                <FormItem label="范围" prop="range">
                    <Input v-model="ruleForm.range" placeholder="例：.zfxxgk_zdgkc li"></Input>
                </FormItem>
                <FormItem label="规则" prop="rules">
                    <Input type="textarea" :rows="10" v-model="ruleForm.rules" placeholder="采集规则" style="margin-bottom:5px"></Input>
                    <code></code>
                    <Tag color="default">例：{"title":["a","text"],"link":["a","href"],"date":["b","text"]}</Tag>
                </FormItem>
                <FormItem label="状态" prop="status">
                    <i-switch :false-value="0" :true-value="1" v-model="ruleForm.status"></i-switch>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="handleSubmit()">提交</Button>
                    <Button @click="handleReset" style="margin-left: 8px">重置</Button>
                </FormItem>
            </Form>
        </Drawer>
    </div>
  </content-layout>
</template>

<script>
  // import {formatTime} from '../util/filter'
  import { fetch, post } from '../fetch/api'
  import HighlightText from '../components/HighlightText'

  export default {
    name: 'collectData',
    components: {
        ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      return {
        title: '数据',
        tabs: [
          {'title': '列表', 'key': '/data', 'visible': true}
        ],
        ruleFromVisible: false,
        activeTab: '/data',
        spinShow: true,
        params: {
            title: '',
            rule_ids: [],
            page: 1
        },
        ruleParams: {
            title: '',
            page: 1
        },
        ruleIds: [],
        ruleColumns: [
            {type: 'selection', width: 55, align: 'center'},
            {title: '数据源', key: 'title', render: (h, params) => {
                return h('a', {attrs: {
                        href: params.row.path,
                        target: '_blank'
                    }},[
                    h('div', {attrs: {style: "font-size: 14px"}}, params.row.title)
                ])
            }},
            {
                title: ' ',
                width: 70,
                align: 'right',
                render: (h, params) => {
                    return h('Button', {props: {size: 'small'}, on: {
                        click: () => {
                            this.ruleForm = JSON.parse(JSON.stringify(params.row))
                            this.addRule()
                        }
                    }}, '编辑')
                }, renderHeader: (h) => {
                    return h('Button', {props: {size: 'small'}, on: {
                        click: () => {
                            this.ruleForm.id = 0
                            this.handleReset()
                            this.addRule()
                        }
                    }},'添加')
                }
            }
        ],
        columns: [
            {type: 'index', width: 60, align: 'center'},
            {title: '发布/截止时间', width: 130, key: 'date'},
            {title: '标题', minWidth: 200, key: 'title', render: (h, params) => {
                return h('a', {attrs: {
                        href: params.row.link,
                        target: '_blank'
                    }},[
                    h(HighlightText, {props: {content: params.row.title, keyword: this.params.title}, attrs: {style: "font-size: 14px"}}),
                    h('div', {attrs: {style: "color: #999"}}, params.row.link)
                ])
            }},
            {title: '采集时间', width: 180, key: 'created_at'}
        ],
        isSub: false,
        loadState: false,
        loadText: '正在加载...',
        lists: {},
        rules: {},
        keys: {},
        ruleForm: {
            id: 0,
            title: '',
            range: '',
            path: '',
            rules: '',
            status: 1
        },
        ruleValidate: {
            title: [
                { required: true, message: '请输入网站名称', trigger: 'blur' }
            ],
            path: [
                { required: true, message: '请输入网址', trigger: 'blur' },
                { type: 'url', message: '网址格式不正确', trigger: 'blur' }
            ],
            range: [
                { required: true, message: '请输入数据范围', trigger: 'change' }
            ],
            rules: [
                { required: true, message: '请输入规则', trigger: 'blur' }
            ]
        }
      }
    },
    watch: {
    },
    mounted () {
        this.groupLoad()
    },
    methods: {
        async groupLoad() {
            this.$store.state.loadingState = true
            this.spinShow = true
            await this.fetchData()
            await this.fetchRules()
            await this.fetchKeys()
            this.$store.state.loadingState = false
            this.spinShow = false
            
        },
        addRule() {
            this.ruleFromVisible = true
        },
        ruleSelect(data) {
            this.params.rule_ids = []
            data.forEach(el => {
                this.params.rule_ids.push(el.id)
            });
        },
        fetchRules () {
            let params = JSON.parse(JSON.stringify(this.ruleParams))
            this.rules = {}
            fetch(`collect/rules`, {params: params}).then(res => {
                this.rules = res
            })
        },
        fetchKeys () {
            let params = JSON.parse(JSON.stringify(this.ruleParams))
            this.rules = {}
            fetch(`collect/keys`, {params: params}).then(res => {
                this.keys = res
            })
        },
        fetchData () {
            let params = JSON.parse(JSON.stringify(this.params))
            this.lists = {}
            fetch(`collect/data`, {params: params}).then(res => {
                this.lists = res
            })
        },
        pagerChange (page) {
            this.params.page = page
            this.fetchData()
        },
        keySearch(key) {
            this.params.title = key
            this.search()
        },
        search() {
            this.params.page = 1
            this.fetchData()
        },
        handleSubmit () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(this.ruleForm)
                    post(`collect/rule/${this.ruleForm.id}`, this.ruleForm).then(res => {
                        if (res.error_code == 0) {
                            this.$Message.success(res.message);
                            this.getRules()
                            this.ruleFromVisible = false
                        } else {
                            this.$Message.error(res.message);
                        }
                    })
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        handleReset () {
            this.$refs.ruleForm.resetFields();
        }
    }
  }
</script>
